import { ClassifiersPage } from './ClassifiersPage'

export default ClassifiersPage
